export const getOptionsToCustomSelect = (list, keys) => {
    return list.map((item) => ({
        value: item[keys.id],
        text: item[keys.text],
        description: item?.description || null
    }));
}